import {FreeSpinsView} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsView';
import {SpineAnimation} from '@fantasmagames/core/src/display/SpineAnimation';
import {WinNumbers} from '@fantasmagames/slot/src/modules/winpresentation/WinNumbers';
import {Position} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import Container = PIXI.Container;

export class GameFreeSpinsView extends FreeSpinsView {

	protected replaceInfoElementComponents(): void {
		super.replaceInfoElementComponents();

		this.addWonFreeSpinsNumber(this._freeSpins);
	}

	public addWonFreeSpinsNumber(wonFreeSpins: number): void {
		if (!(wonFreeSpins === 10 || wonFreeSpins === 15 || wonFreeSpins === 20)) {
			wonFreeSpins = 10; // TODO: temporary
		}
		const title: PIXI.Sprite = new PIXI.Sprite(
			this.resources.getLocaleTextImage(`AWARDED_${wonFreeSpins}_FS.png`),
		);

		this.spineUtils.replaceElementInSpineMultiTrack(
			this._currentFeatureAnimation,
			`FREE_SPINS_FEATURE_1_1_NUMBER`,
			title,
		);
	}

	public showAddedFreespins(addedFreeSpins: number): void {
		const animation: SpineAnimation =
			this.spineUtils.startSpineAnimationCreation('TEXT_ANNOUNCEMENT.json', 'POP_UP', false)
				.position(this.layout.getAbsolutePosition('POPUP_SCREEN'))
				.onComplete(() => {
					this.emit(FreeSpinsView.RETRIGGER_FINISHED);
				})
				.createAndStart();
		animation.timeScale = 0.6;

		const retriggetText: PIXI.Sprite = this.createFreeSpinsRetriggerText(addedFreeSpins);
		this.spineUtils.replaceElementInSpineAnimation(animation, 'NUMBER', retriggetText);

		const bounds = retriggetText.getLocalBounds();

		const scale = Math.min(1, (this.resolutionManager.resolution.width * 0.9) / bounds.width);
		retriggetText.scale.set(scale, -scale);
		retriggetText.x = -bounds.width * scale / 2;
		retriggetText.y = bounds.height * scale / 2;

		this.emit(FreeSpinsView.RETRIGGER_STARTED);
	}

	protected createFreeSpinsRetriggerText(addFreeSpins: number): PIXI.Sprite {
		const fullText: PIXI.Sprite = new PIXI.Sprite();

		const plus: PIXI.Sprite = new PIXI.Sprite(
			this.resources.getSpritesheetTexture('NUMBERS.json', `LARGE_PLUS.png`),
		);
		fullText.addChild(plus);

		if (!(addFreeSpins === 10 || addFreeSpins === 15 || addFreeSpins === 20)) {
			addFreeSpins = 10; // TODO: temporary
		}

		const number: PIXI.Sprite = new PIXI.Sprite(this.resources.getLocaleTextImage(`AWARDED_${addFreeSpins}_FS.png`));
		fullText.addChild(number);
		number.position.x += plus.width;

		const freespins: PIXI.Sprite = new PIXI.Sprite(this.resources.getLocaleTextImage(`FREESPINS_RETRIGGER.png`));
		fullText.addChild(freespins);
		freespins.position.x += plus.width + number.width;

		const maxHeight = Math.max(...(fullText.children as Container[]).map(child => child.height));

		fullText.children.forEach((child: Container) => {
			child.y = (maxHeight - child.height) * 0.5;
		});

		return fullText;
	}

	public showWinSummaryScreen(totalWin: number, maximumSizeInPixels?: number): void {
		this.killWinSummaryScreen();

		if (totalWin === 0) {
			this._winSummaryScreenAnimation = this.spineUtils
				.startSpineAnimationCreation('FREESPIN_COMPLETE_SCREEN.json', 'START', false)
				.chainIdleAnimation('IDLE')
				.onComplete(() => {
					this.emit(FreeSpinsView.SHOWING_WIN_SUMMARY_SCREEN);
				})
				.position(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height)
				.container(this.container)
				.createAndStart();

			const textImage: PIXI.Sprite = this.getLocaleTextImage('FREESPIN_COMPLETE');

			this.spineUtils.replaceElementInSpineAnimation(this._winSummaryScreenAnimation, 'TEXT', textImage);
			this.adjustWinScreenLocalizedScale(textImage, true);
		} else {
			this._winSummaryScreenAnimation = this.spineUtils
				.startSpineAnimationCreation('WIN_SCREEN.json', 'START', false)
				.chainIdleAnimation('IDLE')
				.onComplete(() => {
					this.emit(FreeSpinsView.SHOWING_WIN_SUMMARY_SCREEN);
					this.fitElementIntoScreen(winAmount);
				})
				.position(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height)
				.container(this.container)
				.createAndStart();

			const textImage: PIXI.Sprite = this.getLocaleTextImage('WIN_SCREEN');
			this.spineUtils.replaceElementInSpineAnimation(this._winSummaryScreenAnimation, 'TEXT', textImage);
			this.adjustWinScreenLocalizedScale(textImage, false);

			const winAmount: WinNumbers = new WinNumbers(this.resources, this.getWinnumberSize(this.device.isMobile));

			winAmount.currencyISO = this.currencyFormatter.currency;
			winAmount.currencySign = this.currencyFormatter.currencySign;
			winAmount.numberAnchor.y = 0.5;
			winAmount.numberKerning = -15;
			winAmount.showNumber(this.currencyFormatter.formatCurrencyApi(totalWin));

			this.spineUtils.replaceElementInSpineAnimation(this._winSummaryScreenAnimation, 'NUMBER', winAmount);
			this.fitElementIntoScreen(winAmount);
		}

		this._exitButton = this.spineUtils.createSpineButton(
			'FREESPIN_BUTTON.json',
			this.onExitWinSummaryButtonClicked.bind(this),
			true,
			false,
			false,
			false,
		);

		const playPosition: Position = this.spineUtils.getBoneAbsolutePosition(
			this.resources.getSpine('FREESPIN_STARTSCREEN.json'),
			'PLAY_BUTTON',
		);
		playPosition.y *= -1;

		this.container.addChild(this._exitButton);
		this._exitButton.position.set(playPosition.x, playPosition.y);
		this.soundPlayer.play('freeSpinsExit');
	}

	protected get numberElementLimit(): number {
		return this.resolutionManager.resolution.width * 0.65;
	}
}



// WEBPACK FOOTER //
// ./src/freespins/GameFreeSpinsView.ts